import { render, staticRenderFns } from "./Phase2Dropdown.vue?vue&type=template&id=0f164968"
import script from "./Phase2Dropdown.vue?vue&type=script&lang=js"
export * from "./Phase2Dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f164968')) {
      api.createRecord('0f164968', component.options)
    } else {
      api.reload('0f164968', component.options)
    }
    module.hot.accept("./Phase2Dropdown.vue?vue&type=template&id=0f164968", function () {
      api.rerender('0f164968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/phase2/Phase2Dropdown.vue"
export default component.exports